import { PctHttpErrorResponse } from './pct-http-error-response';

export class HandledErrorResponse extends PctHttpErrorResponse {
  constructor(
    message: string,
    status: number,
    response: any,
    headers: {
      [key: string]: any;
    },
    originalError?: Error,
  ) {
    super(message, status, response, headers, originalError);
  }
}
